/** Uses local backend during `npm run dev`; production keeps Render. */
export function getFormSubmitUrl() {
  if (typeof window === "undefined") {
    return "https://dalhousiecombatroboticsteam.onrender.com/submit-form";
  }
  const { hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `${window.location.protocol}//${hostname}:5001/submit-form`;
  }
  return "https://dalhousiecombatroboticsteam.onrender.com/submit-form";
}

/** POST JSON and parse body safely (handles empty or non-JSON error pages). */
export async function postFormJson(url, payload) {
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const text = await response.text();
  let data = {};
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = { message: text.slice(0, 500) };
    }
  }
  return { response, data };
}
